<template>
  <div :class="classes" :id="id">
    <div class="products-display bg-light">
      <div
        class="product-line"
        :class="show_all_products ? 'pb-4 mb-4 border-bottom' : ''"
        v-for="(product, i) in products_to_show"
        :key="i"
      >
        <h4 v-if="show_all_products">
          {{ $t("message.contracts.sad_product_line") }} {{ i + 1 }}
        </h4>
        <form-sad-subitems
          :product="product"
          :product_index="i"
          :is_in_product="true"
          :current_fields="current_fields"
          :gtd="gtd"
          :errors="errors"
        />
      </div>
      <button
        class="btn btn-sm btn-success"
        v-if="show_add_button"
        @click="show_more"
      >
        {{
          $t(
            "message.contracts." +
              (show_all_products
                ? "sad_hide_more_products_button"
                : "sad_show_more_products_button"),
          )
        }}
      </button>
    </div>
  </div>
</template>
<script>
// import FormSadSubitems from '../contracts/form-sad-subitems.vue'
export default {
  name: "sad-product-field",
  // components: {FormSadSubitems},
  props: {
    gtd: {
      type: Object,
      default: () => {
        return {};
      },
    },
    classes: String,
    id: String,
    current_fields: {
      type: Array,
      default: () => {
        return [];
      },
    },
    errors: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      show_all_products: false,
    };
  },
  methods: {
    show_more() {
      this.show_all_products = !this.show_all_products;
    },
  },
  computed: {
    products_to_show() {
      if (this.show_all_products) return this.gtd.products;
      return [this.gtd.products[0]];
    },
    show_add_button() {
      if (this.gtd.g5 > 1) return true;
      return false;
    },
  },
};
</script>
<style scoped>
.products-display {
  margin: 0 -2.15rem;
  padding: 2.15rem;
}
</style>
